import React, {Component} from 'react';

import { Button, Callout, Intent, MenuItem, Spinner } from '@blueprintjs/core';
import {Select} from "@blueprintjs/select";
import {Column, Cell, SelectionModes, RenderMode, Table} from "@blueprintjs/table";
import toastr from 'toastr';

import {getCurrentUserId, getCurrentUserName, getJwt} from '../../../services/authService';
// import ReactGA from 'react-ga';
import http from '../../../services/httpService';
import TableNoData from '../../common/TableNoData';
import CancelProPlan from '../../modals/CancelProPlan';
import ClaimFreeNumberModal from '../../modals/ClaimFreeNumberModal';


import OrderSummary from '../addFunds/OrderSummary';
import countries from '../../common/countries';
import usStates from '../../common/usStates';
import caStates from '../../common/canadaStates';

import sizeMe from 'react-sizeme';
import RetinaImage from "react-retina-image";


let spinnerComponent = <div style={{marginBottom: 7, marginLeft: 10}}><Spinner size={15}/></div>

class PhoneNumbers extends Component {

    state = {
        loader: false,
        selectedSource: '',
        fundsAmount: '0',
        amount: '',
        countryCode: 'US',
        selectedCountry: 'United States',
        selectedCountryFlag: '🇺🇸',
        filteredCountries: [],
        selectedState: {
            abbreviation: 'any',
            name: '',
            areaCode: ''
        },
        filteredStates: [],
        addedNumbers: [],
        spinnerActive: false,
        phoneNumberTypes: [],
        selectedPhoneNumberType: 'all types',
        phoneNumbers: [],
        filteredPhoneNumbers: [],
        local_numbers: [],
        toll_free_numbers: [],
        mobile_numbers: [],
        national_numbers: [],
        addedButtonHovered: '',
        listOfEuAbbreviations: ['BE', 'BG', 'CZ', 'DK', 'DE', 'EE', 'IE', 'EL', 'ES', 'FR', 'GR', 'HR', 'IT', 'CY', 'LV',
            'LT', 'LU', 'HU', 'MT', 'NL', 'AT', 'PL', 'PT', 'RO', 'SI', 'SK', 'FI', 'SE', 'UK', 'GB'],
        shouldAddVat: false,
        errorGettingPhones: true,
        regulatory_compliance: [],
        regulatoryCheck: false,
        claimFreeNumberModalActive: false,
        claimFreeNumberModalData: [],
        claimFreeNumberLoader: false,
        showFreeNumberSuccessText: false
    };

    


    analytics = () => {
      //  ReactGA.set({userId: getCurrentUserId()});
      //  ReactGA.pageview(window.location.pathname + window.location.search);
    };

    async componentDidMount() {
        // ReactGA.initialize('UA-90436832-5', {
        //     debug: false,
        //     titleCase: false,
        //     gaOptions: {
        //         userId: getCurrentUserId()
        //     }
        // });
        this.analytics();

        const user_id = await getCurrentUserId();
        let projectId = await this.props.selectedSource ? this.props.selectedSource : JSON.parse(localStorage.source_clicked);
        let user = await this.props.user;
        let project = await user.sources.data.find(project => projectId.toString() === project.id.toString());
        if (project && project.default_billing_details && project.default_billing_details.address &&
            project.default_billing_details.address.country && !project.default_billing_details.vat_number) {
            await this.state.listOfEuAbbreviations.map(country => country === project.default_billing_details.address.country ? this.setState({shouldAddVat: true}) : '');
        }

        if (!user_id && (window.location.pathname !== "/login" && window.location.pathname !== "/register")) {
            window.location = "/login";
        }

        let statesData = await usStates;
        let filteredStates = await [];
        await statesData.map(state => state.areaCodes.length === 1 ? filteredStates.push({
                "abbreviation": state.abbreviation,
                "name": state.name,
                "areaCode": state.areaCodes[0]
            })
            :
            state.areaCodes.map((areaCode, index) => filteredStates.push({
                "abbreviation": state.abbreviation,
                "name": state.name,
                "areaCode": state.areaCodes[index]
            }))
        )

        await this.setState({filteredCountries: countries, filteredStates, regulatory_compliance: this.props.selectedSourceNode.regulatory_compliance || []})

        if (this.props.location.state && this.props.location.state.amount && this.props.location.state.addedNumbers) {
            this.setState({
                fundsAmount: this.props.location.state.amount,
                addedNumbers: this.props.location.state.addedNumbers
            })
        }
        try {
            await this.getNumbersData()
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Error Code #22058: Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error('Error Code #22059: '+ex.response.data.message);
                this.props.history.push('/logout');
            }
        }
        await this.recalculateColsWidth(1030)
    }

    async componentDidUpdate() {
        let user = this.props.user;
        if (!this.state.loader && this.props.selectedSource && ((this.state.selectedSource.toString() !== this.props.selectedSource.toString()) || (user.id && !this.state.user) && (!this.state.phoneNumbers || this.state.phoneNumbers.length === 0))) {
            await this.setState({
                loader: true,
                selectedSource: this.props.selectedSource,
                regulatory_compliance: this.props.selectedSourceNode.regulatory_compliance || []
            })
            await this.getNumbersData();
        }
    }

    getNumbersData = async () => {
        let projectId = await this.props.selectedSource ? this.props.selectedSource : JSON.parse(localStorage.source_clicked);
        let user = await this.props.user;
        // console.log('getNumbersData: ', projectId, user)
        if (user && user.id && projectId) {
            try {
                // this.setState({loader: false})
                await this.setState({loader: true, user})
                const pageSize = await this.state.pageSize;
                let selectedSubType = await this.props.selectedSubType;
                let selectedSource = await this.props.selectedSource || '';
                // let selectedSource = '1160';
                let result = ''
                if (this.state.countryCode === 'US' || this.state.countryCode === 'CA') {
                    result = await http.post('/api/project/' + projectId + '/phones_twilio_filtered/number_count/2', {
                        countryCode: this.state.countryCode,
                        areaCode: this.state.selectedState.areaCode || null,
                        numberType: this.state.selectedPhoneNumberType === 'all types' ? 'all' : this.state.selectedPhoneNumberType ?
                            this.state.selectedPhoneNumberType : null
                    }, {headers: {authorization: getJwt()}});
                } else {
                    result = await http.post('/api/project/' + projectId + '/phones_twilio/number_count/2', {
                        countryCode: this.state.countryCode,
                        numberType: this.state.selectedPhoneNumberType === 'all types' ? 'all' : this.state.selectedPhoneNumberType ?
                            this.state.selectedPhoneNumberType : null
                    }, {headers: {authorization: getJwt()}});
                }

                const data = await result.data
                // await console.log('Evo ga rezultat za phone numbers: ', data)
                let phoneNumberTypes = await [{number_type: 'all types'}];
                let phoneNumbers = await [];
                if (data.local_numbers && data.local_numbers.length) {
                    let pricesData = await data.phone_number_prices.phoneNumberPrices.find(type => type.number_type === 'local');
                    phoneNumberTypes = [...phoneNumberTypes, pricesData]

                    await data.local_numbers.map(number => phoneNumbers = [...phoneNumbers, {
                        ...number,
                        ...pricesData
                    }])
                    // phoneNumbers = await [...phoneNumbers, ...data.local_numbers]
                }
                if (data.toll_free_numbers && data.toll_free_numbers.length) {
                    let pricesData = data.phone_number_prices.phoneNumberPrices.find(type => type.number_type === 'toll free');
                    phoneNumberTypes = [...phoneNumberTypes, pricesData]

                    await data.toll_free_numbers.map(number => phoneNumbers = [...phoneNumbers, {
                        ...number,
                        ...pricesData
                    }])
                    // phoneNumbers = await [...phoneNumbers, ...data.toll_free_numbers]
                }
                if (data.mobile_numbers && data.mobile_numbers.length) {
                    let pricesData = data.phone_number_prices.phoneNumberPrices.find(type => type.number_type === 'mobile');
                    phoneNumberTypes = [...phoneNumberTypes, pricesData]

                    await data.mobile_numbers.map(number => phoneNumbers = [...phoneNumbers, {
                        ...number,
                        ...pricesData
                    }])
                    //phoneNumbers = await [...phoneNumbers, ...data.mobile_numbers]
                }
                if (data.national_numbers && data.national_numbers.length) {
                    let pricesData = data.phone_number_prices.phoneNumberPrices.find(type => type.number_type === 'national');
                    phoneNumberTypes = [...phoneNumberTypes, pricesData]

                    await data.national_numbers.map(number => phoneNumbers = [...phoneNumbers, {
                        ...number,
                        ...pricesData
                    }])
                    //phoneNumbers = await [...phoneNumbers, ...data.national_numbers]
                }
                //console.log('phoneNumbers all: ', phoneNumbers)
                await this.setState({
                    selectedSource,
                    phoneNumberTypes,
                    phoneNumbers,
                    loader: false,
                    errorGettingPhones: false
                })

                if (!this.state.phoneNumbers) {
                    this.setState({loader: false})
                }
                await this.setState({forceTableRerender: true})
                await this.setState({forceTableRerender: false})
            } catch (ex) {
                if (ex.response && ex.response.status === 404)
                    // toastr.error("Something went wrong... Please refresh and try again.");
                    this.setState({loader: false, posts: '', errorGettingPhones: true, rowHeights: []})
                if (ex.response && ex.response.status === 401) {
                    toastr.error('Error Code #22060: '+ex.response.data.message);
                    this.props.history.push('/logout');
                }
            }
        }

    }

    /* Regular Cell */
    countryCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.phoneNumbers[rowIndex];
        // Temporarly placed for removing loader state
        if ((rowIndex === (this.state.lastPage ? this.state.lastPageSize : this.state.pageSize) - 1) && this.state.loader) {
            setTimeout(() => this.setState({loader: false}), 2500)
        }

        return <Cell
            className=''
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className="billing-text-container">
                {/*<i className="fas fa-eye eye-icon" onClick={()=>console.log('Kliknuo sam')}></i>*/}

                {this.state.loader ? spinnerComponent :
                    <p style={{fontSize: 25, textAlign: 'center', width: '100%'}}>{this.state.selectedCountryFlag}</p>}
            </div>
        </Cell>

    };

    /* Loading Cell */
    countryCellRendererLoading = (rowIndex, columnIndex) => {

        return <Cell
            className='campaign-name'
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className="type-container">
                {/*<i className="fas fa-eye eye-icon"></i>*/}
                <div>
                    {spinnerComponent}
                </div>
            </div>
        </Cell>
    };

    /* Regular Cell */
    informationCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.filteredPhoneNumbers.length ? this.state.filteredPhoneNumbers[rowIndex] : this.state.phoneNumbers[rowIndex];

        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className='billing-text-container'>

                {this.state.loader ?
                    <div className='bp3-skeleton text-skeleton'/>
                    :
                    <p className={this.state.loader ? 'bp3-skeleton' : ''}>{item.phoneNumber}</p>
                }
            </div>
        </Cell>
    };

    /* Loading Cell */
    informationCellRendererLoading = (rowIndex, columnIndex) => {
        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className='billing-text-container'>
                <div className='bp3-skeleton text-skeleton'/>
            </div>
        </Cell>
    }

    /* Regular Cell */
    typeCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.filteredPhoneNumbers.length ? this.state.filteredPhoneNumbers[rowIndex] : this.state.phoneNumbers[rowIndex];

        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className='billing-text-container'>
                {this.state.loader ?
                    <div className='bp3-skeleton text-skeleton'/>
                    :
                    <p className={this.state.loader ? 'bp3-skeleton' : ''}>{item.number_type}</p>
                }
            </div>
        </Cell>
    };

    /* Loading Cell */
    typeCellRendererLoading = (rowIndex, columnIndex) => {
        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className='billing-text-container'>
                <div className='bp3-skeleton text-skeleton'/>
            </div>
        </Cell>
    }

    /* Regular Cell */
    capabilityCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.filteredPhoneNumbers.length ? this.state.filteredPhoneNumbers[rowIndex] : this.state.phoneNumbers[rowIndex];

        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className='billing-text-container'>
                {this.state.loader ?
                    <div className='bp3-skeleton text-skeleton'/>
                    :
                    <p className={this.state.loader ? 'bp3-skeleton' : ''}>
                        {item.capabilities.SMS ? 'SMS ' : ''}
                        {item.capabilities.MMS ? 'MMS ' : ''}
                        {item.capabilities.fax ? 'fax ' : ''}
                        {item.capabilities.voice ? 'voice ' : ''}
                    </p>
                }
            </div>
        </Cell>
    };

    /* Loading Cell */
    capabilityCellRendererLoading = (rowIndex, columnIndex) => {
        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className='billing-text-container'>
                <div className='bp3-skeleton text-skeleton'/>
            </div>
        </Cell>
    }

    /* Regular Cell */
    setupFeeCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.filteredPhoneNumbers.length ? this.state.filteredPhoneNumbers[rowIndex] : this.state.phoneNumbers[rowIndex];

        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className='billing-text-container'>
                {this.state.loader ?
                    <div className='bp3-skeleton text-skeleton'/>
                    :
                    <p className={this.state.loader ? 'bp3-skeleton' : ''}>FREE</p>
                }
            </div>
        </Cell>
    };

    /* Loading Cell */
    setupFeeCellRendererLoading = (rowIndex, columnIndex) => {
        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className='billing-text-container'>
                <div className='bp3-skeleton text-skeleton'/>
            </div>
        </Cell>
    }

    /* Regular Cell */
    monthlyFeeCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.filteredPhoneNumbers.length ? this.state.filteredPhoneNumbers[rowIndex] : this.state.phoneNumbers[rowIndex];

        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className='billing-text-container'>
                {this.state.loader ?
                    <div className='bp3-skeleton text-skeleton'/>
                    :
                    <p className={this.state.loader ? 'bp3-skeleton' : ''}>${item.base_price}</p>
                }
            </div>
        </Cell>
    };

    /* Loading Cell */
    monthlyFeeCellRendererLoading = (rowIndex, columnIndex) => {
        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className='billing-text-container'>
                <div className='bp3-skeleton text-skeleton'/>
            </div>
        </Cell>
    }

    /* Regular Cell */
    buttonsCellRenderer = (rowIndex, columnIndex) => {
        const item = this.state.filteredPhoneNumbers.length ? this.state.filteredPhoneNumbers[rowIndex] : this.state.phoneNumbers[rowIndex];
        let added = this.state.addedNumbers.find(number => number.phoneNumber === item.phoneNumber) ? true : false;

        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className='billing-text-container'>
                {this.state.loader ?
                    <div className='bp3-skeleton text-skeleton'/>
                    :

                    added ?
                        <button
                            className={this.state.addedButtonHovered === item.phoneNumber ? 'btn btn-transparent-border' : 'btn btn-green'}
                            onMouseEnter={() => this.setState({addedButtonHovered: item.phoneNumber})}
                            onMouseLeave={() => this.setState({addedButtonHovered: ''})}
                            onClick={() => this.removeFromCart(item)}
                        >
                            {this.state.addedButtonHovered === item.phoneNumber ? 'Remove' : 'Added'}
                        </button>
                        :
                        <button className='btn btn-action' onClick={() => this.addToCart(item)}>Add to Cart</button>

                }
            </div>
        </Cell>
    };

    /* Loading Cell */
    buttonsCellRendererLoading = (rowIndex, columnIndex) => {
        return <Cell
            style={{backgroundColor: rowIndex % 2 === 0 ? 'white' : '#F7F7F7'}}
        >
            <div className='billing-text-container'>
                <div className='bp3-skeleton text-skeleton'/>
            </div>
        </Cell>
    }

    addToCart = async (number) => {
        // console.log('addToCart: ', {...number, countryCode: this.state.countryCode})
        let list = await this.state.addedNumbers;
        let basePrice = parseInt(number.base_price)
        let type = basePrice <= 5 ? 'yearly' : 'monthly';
        let totalPrice = basePrice <= 5 ? (this.state.countryCode === 'US' || this.state.countryCode === 'CA') ?
            basePrice * 24 : basePrice * 12 : basePrice;


        let fundsAmount = await parseInt(this.state.fundsAmount) + totalPrice;

        // console.log('add to cart fundsAmount: ', fundsAmount)
        await this.setState({
            addedNumbers: [...list, {...number, countryCode: this.state.countryCode, type}],
            fundsAmount: fundsAmount.toString()
        })
        // console.log('addToCart: ', fundsAmount, this.state.fundsAmount)
    }

    claimFreeNumber = (number) => {
        let freePhoneToClaim = this.props.selectedSourceNode && this.props.selectedSourceNode.free_phone_to_claim ?
            this.props.selectedSourceNode.free_phone_to_claim : '';
        if(freePhoneToClaim){
            this.setState({
                claimFreeNumberModalData: [{
                    type: number.number_type,
                    country: this.state.countryCode,
                    phone: number.phoneNumber
                }],
                claimFreeNumberModalActive: true
            })
        }
    }

    claimFreeNumberSubmit = async () => {
        if(this.state.claimFreeNumberModalData && this.state.claimFreeNumberModalData.length){
            this.setState({claimFreeNumberLoader:true})
            try{
                const claimPhoneResult = await http.post('api/project/' + this.props.selectedSource + '/phones_claim',{
                    phone_numbers: this.state.claimFreeNumberModalData
                }, {headers: {authorization: getJwt()}})
                // console.log('claimPhoneResult: ', claimPhoneResult)
                if (claimPhoneResult.data && claimPhoneResult.data.phone_numbers && claimPhoneResult.data.phone_numbers.length &&
                    claimPhoneResult.data.phone_numbers[0].phone_success){
                    this.setState({showFreeNumberSuccessText: true})
                }else{
                    this.setState({
                        claimFreeNumberLoader: false
                    })
                    toastr.error(claimPhoneResult && claimPhoneResult.data && claimPhoneResult.data.error && claimPhoneResult.data.message ?
                        claimPhoneResult.data.message : 'Error with claiming free number, please try again')
                }

            }catch(e){
                toastr.error('Error with claiming free number, please try again')
            }
        }
    }

    handleFreeNumberFinishedContinuePurchase = () => {
        this.setState({
            claimFreeNumberModalData: [],
            claimFreeNumberModalActive: false,
            claimFreeNumberLoader: false,
            showFreeNumberSuccessText: false
        });
        this.getNumbersData();
        this.props.updateUserFromServer();
    }

    handleFreeNumberFinishedGoBack = () => {
        this.setState({
            claimFreeNumberModalData: [],
            claimFreeNumberModalActive: false,
            claimFreeNumberLoader: false,
            showFreeNumberSuccessText: false
        });
        this.props.updateUserFromServer();
        this.props.history.push('/channels/sms/sender-pool')
    }

    removeFromCart = async (number) => {
        let list = await this.state.addedNumbers;
        let filteredList = await list.filter(item => item.phoneNumber !== number.phoneNumber)
        await this.setState({addedNumbers: filteredList})

        let basePrice = parseInt(number.base_price)

        let totalPrice = basePrice <= 5 ? (this.state.countryCode === 'US' || this.state.countryCode === 'CA') ?
            basePrice * 24 : basePrice * 12 : basePrice;
        let fundsAmount = await parseInt(this.state.fundsAmount) - totalPrice;
        await this.setState({fundsAmount: fundsAmount.toString()})
    }

    filterItems = (q) => {
        function escapeRegExp(s) {
            return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        }

        const words = q
            .split(/\s+/g)
            .map(s => s.trim())
            .filter(s => !!s);
        const hasTrailingSpace = q.endsWith(" ");
        const searchRegex = new RegExp(
            words
                .map((word, i) => {
                    if (i + 1 === words.length && !hasTrailingSpace) {
                        // The last word - ok with the word being "startswith"-like
                        return `(?=.*\\b${escapeRegExp(word)})`;
                    } else {
                        // Not the last word - expect the whole word exactly
                        return `(?=.*\\b${escapeRegExp(word)}\\b)`;
                    }
                })
                .join("") + ".+",
            "gi"
        );
        // console.log('Words: ', words)
        let filteredArray = [];
        countries.filter(item => {
            let imamIme = searchRegex.test(item.name);
            searchRegex.lastIndex = 0;
            return imamIme ? filteredArray.push(item) : null;
        });
        this.setState({
            filteredCountries: filteredArray
        })
    };

    filterStates = (q) => {
        function escapeRegExp(s) {
            return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        }

        const words = q
            .split(/\s+/g)
            .map(s => s.trim())
            .filter(s => !!s);
        const hasTrailingSpace = q.endsWith(" ");
        const searchRegex = new RegExp(
            words
                .map((word, i) => {
                    if (i + 1 === words.length && !hasTrailingSpace) {
                        // The last word - ok with the word being "startswith"-like
                        return `(?=.*\\b${escapeRegExp(word)})`;
                    } else {
                        // Not the last word - expect the whole word exactly
                        return `(?=.*\\b${escapeRegExp(word)}\\b)`;
                    }
                })
                .join("") + ".+",
            "gi"
        );
        // console.log('Words: ', words)
        let filteredArray = [];

        let statesData = this.state.countryCode === 'US' ? usStates : caStates;
        let listOfStates = [];
        statesData.map(state => state.areaCodes.length === 1 ? listOfStates.push({
                "abbreviation": state.abbreviation,
                "name": state.name,
                "areaCode": state.areaCodes[0]
            })
            :
            state.areaCodes.map((areaCode, index) => listOfStates.push({
                "abbreviation": state.abbreviation,
                "name": state.name,
                "areaCode": state.areaCodes[index]
            }))
        )

        listOfStates.filter(item => {
            let imamIme = searchRegex.test(item.name);
            searchRegex.lastIndex = 0;
            return imamIme ? filteredArray.push(item) : null;
        });
        this.setState({
            filteredStates: filteredArray
        })
    };

    recalculateColsWidth = async () => {
        let containerWidth = this.props.size.width;
        let tableTotalWidth = containerWidth > 1500 ? 1535 : containerWidth > 1300 ? 1335 : containerWidth * 0.9;
        let lastWidth = (containerWidth - tableTotalWidth) > 0 ? (containerWidth - tableTotalWidth) : 150;
        // console.log('colsWidth: ', containerWidth, tableTotalWidth, lastWidth )
        if ((this.state.lastColumnWidth !== lastWidth) && (lastWidth > 0) && containerWidth > 0) {
            await this.setState({lastColumnWidth: lastWidth > 120 ? lastWidth : 120})
            await this.setState({forceTableRerender: true})
            await this.setState({forceTableRerender: false})
        }
    }

    handleProceedToCheckout = async () => {
        this.setState({spinnerActive: true})
        let user = await this.props.user;
        let projectId = await this.props.selectedSource ? this.props.selectedSource : JSON.parse(localStorage.source_clicked);
        let project = await user.sources.data.find(project => projectId.toString() === project.id.toString())
        let smsPlatform = project ? project.platforms.find(plan => plan.platform === 'sms') : '';

        if (user && user.customer && project) {
            /*GET PAYMENT METHODS PROJECT*/
            try {
                const result = await http.get('/api/user/' + user.id + '/project/' + projectId + '/customers/get_payment_methods_project', {headers: {authorization: getJwt()}});
                let projectPaymentMethods = await result.data.project_payment_methods;
                let userPaymentMethods = await result.data.user_payment_methods;

                if (
                    (userPaymentMethods && userPaymentMethods.length && userPaymentMethods[0].payment_method_id) ||
                    (projectPaymentMethods && projectPaymentMethods.length && projectPaymentMethods[0].payment_method_id)
                ) {
                    this.props.history.push('/pay-phone-numbers-existing-payment', {
                        amount: this.state.fundsAmount,
                        addedNumbers: this.state.addedNumbers
                    })
                } else {
                    this.props.history.push('/pay-phone-numbers/billing-details', {
                        amount: this.state.fundsAmount,
                        addedNumbers: this.state.addedNumbers
                    })
                }
                // console.log('projectPaymentMethods: ', projectPaymentMethods);
                // console.log('userPaymentMethods: ', userPaymentMethods);
                this.setState({spinnerActive: false})
            } catch (ex) {
                toastr.error("Error Code #22061: Couldn't receive payment methods, please try again.");
                this.setState({spinnerActiveId: false})
            }

        } else if (user && !user.customer && project) {
            let userId = user.id || getCurrentUserId();
            try {
                const stripeResult = await http.post('api/user/' + userId + '/project/' + projectId + '/customers/create_customer', {}, {headers: {authorization: getJwt()}})
                // console.log('stripe customer results: ', stripeResult)
                this.props.history.push('/pay-phone-numbers/billing-details', {amount: this.state.fundsAmount})
            } catch (ex) {
                toastr.error("Error Code #22062: Stripe customer was not created, please try again.");
                this.setState({spinnerActive: false})
            }
        }
    }

    handleChooseCountry = async (item) => {
        // let arrayOfCompliances = await ['AT'];
        let arrayOfCompliances = await this.state.regulatory_compliance;
        let regulatoryCheck = await false;
        await arrayOfCompliances.map(e=> e === item.code ? regulatoryCheck = true : '')
        // console.log('regulatoryCheck: ', regulatoryCheck)

        await this.setState({
            countryCode: item.code,
            selectedCountry: item.name,
            selectedCountryFlag: item.flag,
            selectedPhoneNumberType: 'all types',
            filteredPhoneNumbers: [],
            regulatoryCheck
        })
        if (this.state.countryCode === 'US' || this.state.countryCode === 'CA') {
            let statesData = await this.state.countryCode === 'US' ? usStates : caStates;
            let filteredStates = await [];
            await statesData.map(state => state.areaCodes.length === 1 ? filteredStates.push({
                    "abbreviation": state.abbreviation,
                    "name": state.name,
                    "areaCode": state.areaCodes[0]
                })
                :
                state.areaCodes.map((areaCode, index) => filteredStates.push({
                    "abbreviation": state.abbreviation,
                    "name": state.name,
                    "areaCode": state.areaCodes[index]
                }))
            )
            await this.setState({
                filteredStates,
                selectedState: {
                    abbreviation: 'any',
                    name: '',
                    areaCode: ''
                }
            })
        } else if (this.state.filteredStates.length) {
            await this.setState({
                filteredStates: [],
                selectedState: {
                    abbreviation: 'any',
                    name: '',
                    areaCode: ''
                }
            })
        }
        await this.getNumbersData()
    }

    handleChooseState = async (item) => {
        await this.setState({selectedState: item, selectedPhoneNumberType: 'all types', filteredPhoneNumbers: []})
        await this.getNumbersData()
    }

    handleChoosePhoneNumberType = async (item) => {
        if (item.number_type === 'all types') {
            this.setState({filteredPhoneNumbers: [], selectedPhoneNumberType: 'all types'})
        } else {
            // let filteredPhoneNumbers = this.state.phoneNumbers.filter(number => number.number_type === item.number_type);
            await this.setState({selectedPhoneNumberType: item.number_type})
        }
        await this.getNumbersData()
    }

    noPhoneNumbersAutomationRenderer = () => {
        return <div className='no-contacts-container panel-container margin-top-20'>
            <img src="/img/emptyStates/buying_phone_numbers_alphanumeric.gif"/>
            <h2>The country you selected supports Alphanumeric Sender ID. </h2>
            <p>This means you can send messages without buying a number.<br/>
                Your company name can be displayed as a message sender.</p>
            <div className='flex-direction-row justify-content-center'>
                <button className=' btn-action margin-bottom-10' onClick={() => this.props.history.push('/new/sms')}>
                    Start SMS Campaign
                </button>
            </div>
            <span>or select another country</span>
        </div>
    };

    errorGettingPhonesRenderer = () => {
        return <div className='no-contacts-container panel-container margin-top-20'>
            <img src="/img/emptyStates/buying_phone_numbers_not_found.gif"/>
            <p>Oops.. No numbers found.<br/>
                Check back in a few minutes and try again. </p>
        </div>
    }

    render() {
        let freePhoneToClaim = this.props.selectedSourceNode && this.props.selectedSourceNode.free_phone_to_claim === 1 ?
            this.props.selectedSourceNode.free_phone_to_claim : '';
        // console.log('freePhoneToClaim: ', freePhoneToClaim, this.props.selectedSourceNode)
        return (
            <div className="add-funds-wrapper">
                <div className="top-navigation">
                    <RetinaImage
                        style={{cursor: 'pointer', zIndex: 999}}
                        onClick={() => this.props.history.push('/channels/sms')}
                        src={['/img/small-logo.png', '/img/big-logo.png']}
                        alt="Emitto Mark"/>
                    <div className="navigation-wrapper">

                        <i className="fas fa-chevron-right grey-text"></i>
                        <div className="menu-link">
                            <span className='grey' onClick={() => this.props.history.push('/channels/sms')}>SMS</span>
                        </div>
                        <i className="fas fa-chevron-right"></i>
                        <div className="menu-link">
                            {/*<NavLink to="/subscription-plans" onClick={() => this.handleStepChange(1)}>*/}
                            <span className='regular'>Phone Numbers</span>
                            {/*</NavLink>*/}
                        </div>
                        <i className="fas fa-chevron-right grey-text"></i>
                        <div className="menu-link">
                            {/*<NavLink to="/add-funds/payment" onClick={() => this.handleStepChange(3)}>*/}
                            <span className='grey'>Payment</span>
                            {/*</NavLink>*/}
                        </div>
                    </div>
                </div>
                <div className="main">
                    <div className='add-funds-content-container'>
                        <div className='white-wrapper-full no-padding-mobile' style={{position: 'relative'}}>
                            <h2 className='mobile-margin-top-40'>Buy Phone Numbers</h2>
                            <div className="organize-content-container">
                                <div className='flex-direction-row flex-wrap flex-direction-column-mobile'>
                                    <div className='selector-container margin-top-10 margin-bottom-10'>
                                        <p className="field-title">Choose a country</p>
                                        <Select
                                            items={this.state.filteredCountries}
                                            itemRenderer={(item, index) => <MenuItem
                                                key={index}
                                                onClick={() => this.handleChooseCountry(item)}
                                                text={item.name + ' ' + item.flag}
                                            />}
                                            filterable={true}
                                            onQueryChange={this.filterItems}
                                            resetOnClose={true}
                                        >
                                            <Button
                                                style={{
                                                    width: this.props.size.width > 640 ? 250 : '100%',
                                                    height: 40,
                                                    justifyContent: 'space-between',
                                                    backgroundColor: '#fff',
                                                    color: '#182026'
                                                }}
                                                text={this.state.selectedCountry}
                                                rightIcon="caret-down">
                                            </Button>

                                        </Select>
                                    </div>
                                    {this.state.countryCode === 'US' || this.state.countryCode === 'CA' ?
                                        <div className='selector-container margin-top-10 margin-bottom-10'>
                                            <p className="field-title">Choose a state</p>
                                            <Select
                                                items={[
                                                    {
                                                        abbreviation: 'any',
                                                        name: '',
                                                        areaCode: ''
                                                    },
                                                    ...this.state.filteredStates]}
                                                itemRenderer={(item, index) => <MenuItem
                                                    key={index}
                                                    onClick={() => this.handleChooseState(item)}
                                                    text={item.name ? item.name + ' (' + item.areaCode + ')' : item.abbreviation}
                                                />}
                                                filterable={true}
                                                onQueryChange={this.filterStates}
                                                resetOnClose={true}
                                            >
                                                <Button
                                                    style={{
                                                        width: this.props.size.width > 640 ? 250 : '100%',
                                                        height: 40,
                                                        justifyContent: 'space-between',
                                                        backgroundColor: '#fff',
                                                        color: '#182026'
                                                    }}
                                                    text={this.state.selectedState.areaCode ? this.state.selectedState.abbreviation + ' (' + this.state.selectedState.areaCode + ')' : 'any'}
                                                    rightIcon="caret-down">
                                                </Button>

                                            </Select>
                                        </div>
                                        :
                                        ''
                                    }

                                    <div className='selector-container margin-top-10 margin-bottom-10'>
                                        <p className="field-title">Choose a phone number type</p>
                                        <Select
                                            items={this.state.phoneNumberTypes}
                                            itemRenderer={(item, index) => <MenuItem
                                                key={index}
                                                onClick={() => this.handleChoosePhoneNumberType(item)}
                                                text={item.number_type}
                                            />}
                                            filterable={false}
                                            // onQueryChange={this.filterItems}
                                            resetOnClose={true}
                                        >
                                            <Button
                                                style={{
                                                    width: this.props.size.width > 640 ? 250 : '100%',
                                                    height: 40,
                                                    justifyContent: 'space-between',
                                                    backgroundColor: '#fff',
                                                    color: '#182026'
                                                }}
                                                text={this.state.selectedPhoneNumberType}
                                                rightIcon="caret-down">
                                            </Button>

                                        </Select>
                                    </div>
                                </div>
                            </div>
                            {
                                (this.state.selectedCountry !== 'United States')&&(this.state.selectedCountry !== 'Canada')&&
                                        this.state.phoneNumbers && this.state.phoneNumbers.length && !this.state.loader &&
                                        !this.state.regulatoryCheck ?
                                    <Callout icon='warning-sign' className='viber-callout' intent={ Intent.WARNING }>
                                    In order to buy Phone Numbers from { this.state.selectedCountry } you should Fill out a
                                    <a href="https://emitto.io/sms-regulatory-compliance" target='_blank'>Regulatory Compliance Form</a>.

                                    </Callout>
                                    :
                                    ''
                            }
                            <h3><strong>NUMBERS</strong></h3>
                            {(!this.state.phoneNumbers || (this.state.phoneNumbers && this.state.phoneNumbers.length < 1)) && !this.state.loader ?
                                this.state.errorGettingPhones ? this.errorGettingPhonesRenderer() : this.noPhoneNumbersAutomationRenderer()
                                :
                                // (this.props.selectedSubType.name !== this.state.selectedSubTypeFinished) ?
                                // This should be changed when calls are received
                                (this.state.loader) ?
                                    <div className='numbers-table-container'>
                                        {[1, 2, 3, 4, 5].map((number, index) => {
                                            return <div className='number-container'>
                                                <div className='column-container small'>
                                                    <p className='label'>Country</p>
                                                    <div style={{width: 40, paddingTop: 5}}>
                                                        {spinnerComponent}
                                                    </div>
                                                </div>
                                                <div className='column-container'>
                                                    <p className='label'>Information</p>
                                                    <div className='skeleton-container'>
                                                        <div className='bp3-skeleton text-skeleton'/>
                                                    </div>
                                                </div>
                                                <div className='column-container medium'>
                                                    <p className='label'>Capability</p>
                                                    <div className='skeleton-container'>
                                                        <div className='bp3-skeleton text-skeleton'/>
                                                    </div>
                                                </div>
                                                <div className='column-container medium'>
                                                    <p className='label'>Setup Fee</p>
                                                    <div className='skeleton-container'>
                                                        <div className='bp3-skeleton text-skeleton'/>
                                                    </div>
                                                </div>

                                                <div className='column-container medium'>
                                                    <p className='label'>Monthly Fee</p>
                                                    <div className='skeleton-container'>
                                                        <div className='bp3-skeleton text-skeleton'/>
                                                    </div>
                                                </div>
                                                <div className='column-container'>
                                                    <p className='label'></p>
                                                    <div className='skeleton-container'>
                                                        <div className='bp3-skeleton text-skeleton'/>
                                                    </div>
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                    :
                                    <div className='numbers-table-container'>
                                        {this.state.phoneNumbers.map((number, index) => {
                                            const item = this.state.filteredPhoneNumbers.length ? this.state.filteredPhoneNumbers[index] : this.state.phoneNumbers[index];
                                            let added = this.state.addedNumbers.find(number => number.phoneNumber && item.phoneNumber &&
                                                (number.phoneNumber === item.phoneNumber)) ? true : false;
                                            return <div className='number-container'>
                                                <div className='column-container small'>
                                                    <p className='label'>Country</p>
                                                    <div className="value-container">
                                                        <p style={{
                                                            fontSize: 20,
                                                            textAlign: 'left',
                                                            paddingLeft: 10,
                                                            width: '100%',
                                                            margin: 0
                                                        }}>{this.state.selectedCountryFlag}</p>
                                                    </div>
                                                </div>
                                                <div className='column-container'>
                                                    <p className='label'>Information</p>
                                                    <div className='value-container'>
                                                        <p className={this.state.loader ? 'bp3-skeleton' : ''}>{number.phoneNumber}</p>
                                                    </div>
                                                </div>
                                                <div className='column-container'>
                                                    <p className='label'>Capability</p>
                                                    <div className='value-container'>
                                                        <p className={this.state.loader ? 'bp3-skeleton' : ''}>
                                                            {number.capabilities.SMS ? 'SMS ' : ''}
                                                            {number.capabilities.MMS ? 'MMS ' : ''}
                                                            {number.capabilities.fax ? 'fax ' : ''}
                                                            {number.capabilities.voice ? 'voice ' : ''}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className='column-container medium'>
                                                    <p className='label'>Setup Fee</p>
                                                    <div className='value-container'>
                                                        <p className={this.state.loader ? 'bp3-skeleton' : ''}>FREE</p>
                                                    </div>
                                                </div>

                                                <div className='column-container medium'>
                                                    <p className='label'>{number.base_price <= 5 ? 'Yearly Fee' : 'Monthly Fee' }</p>
                                                    <div className='value-container'>
                                                        { (this.state.selectedCountry === 'United States') && freePhoneToClaim ?
                                                            <p className={ this.state.loader ? 'bp3-skeleton' : '' }>FREE</p>
                                                            :
                                                            <p className={ this.state.loader ? 'bp3-skeleton' : '' }>${
                                                                number.base_price <= 5 ? (this.state.countryCode === 'US' || this.state.countryCode === 'CA') ?
                                                                    (number.base_price * 24).toFixed(2) :
                                                                    (number.base_price * 12).toFixed(2) :
                                                                    number.base_price.toFixed(2) }</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='column-container'>
                                                    <p className='label'></p>
                                                    <div className='value-container'>
                                                        {
                                                            added ?
                                                                <button
                                                                    className={this.state.addedButtonHovered === number.phoneNumber ? 'btn btn-transparent-border btn-small' : 'btn btn-green btn-small'}
                                                                    onMouseEnter={() => this.setState({addedButtonHovered: number.phoneNumber})}
                                                                    onMouseLeave={() => this.setState({addedButtonHovered: ''})}
                                                                    onClick={() => this.removeFromCart(item)}
                                                                >
                                                                    {this.state.addedButtonHovered === number.phoneNumber ? 'Remove' : 'Added'}
                                                                </button>
                                                                :
                                                                (this.state.selectedCountry !== 'United States')&&
                                                                (this.state.selectedCountry !== 'Canada')&&
                                                                !this.state.regulatoryCheck ?
                                                                    <button className='btn btn-action btn-small'
                                                                            disabled={true}
                                                                    >Add to Cart</button>
                                                                    :
                                                                    (this.state.selectedCountry === 'United States') && freePhoneToClaim ?
                                                                    <button className='btn btn-action btn-small'
                                                                            onClick={() => this.claimFreeNumber(number)}>Claim for Free</button>
                                                                    :
                                                                    <button className='btn btn-action btn-small'
                                                                            onClick={() => this.addToCart(number)}>Add to
                                                                        Cart</button>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                // <Table
                                //     className='billing-invoice-table'
                                //     selectionModes={ SelectionModes.NONE }
                                //     columnWidths={ [150, 70, 130, 130, 155, 120, this.state.lastColumnWidth] }
                                //     numRows={ 5 }
                                //     key={5}
                                //     defaultRowHeight={ 70 }
                                //     // rowHeights={ [100, 100, 100, 100, 100, 100, 100, 100, 100, 100] }
                                // >
                                //     {/*<Column*/}
                                //     {/*cellRenderer={ this.questionCellRendererLoading }*/}
                                //     {/*name=""*/}
                                //     {/*/>*/}
                                //     <Column name="" cellRenderer={ this.buttonsCellRendererLoading }/>
                                //     <Column
                                //         cellRenderer={ this.countryCellRendererLoading }
                                //         name="Country"
                                //     />
                                //     <Column
                                //         cellRenderer={ this.informationCellRendererLoading }
                                //         name="Information"
                                //     />
                                //     <Column
                                //         cellRenderer={ this.typeCellRendererLoading }
                                //         name="Type"
                                //     />
                                //     <Column name="Capability" cellRenderer={ this.capabilityCellRendererLoading }/>
                                //     <Column name="Setup Fee" cellRenderer={ this.setupFeeCellRendererLoading }/>
                                //     <Column name="Monthly Fee" cellRenderer={ this.monthlyFeeCellRendererLoading }/>
                                // </Table>
                                // :
                                // <Table
                                //     className='billing-invoice-table'
                                //     resizeRowsByApproximateHeight={ true }
                                //     renderMode={ RenderMode.NONE }
                                //     numRows={ this.state.filteredPhoneNumbers.length || this.state.phoneNumbers.length }
                                //     key={ this.state.filteredPhoneNumbers.length || this.state.phoneNumbers.length }
                                //     selectionModes={ SelectionModes.NONE }
                                //     // defaultRowHeight={ this.state.defaultRowHeight }
                                //     defaultRowHeight={ 70 }
                                //     // rowHeights={ this.state.rowHeights}
                                //     columnWidths={ [150, 70, 130, 130, 155, 120, this.state.lastColumnWidth] }
                                //     onColumnWidthChanged={ async(index, width) => await this.updateTableWidth(index, width) }
                                //     forceRerenderOnSelectionChange={ this.state.forceTableRerender }
                                // >
                                //     {/*<Column*/}
                                //     {/*cellRenderer={ this.questionCellRenderer }*/}
                                //     {/*name=""*/}
                                //     {/*/>*/}
                                //     <Column name="" cellRenderer={ this.buttonsCellRenderer }/>
                                //     <Column
                                //         cellRenderer={ this.countryCellRenderer }
                                //         name="Country"
                                //     />
                                //     <Column
                                //         cellRenderer={ this.informationCellRenderer }
                                //         name="Information"
                                //     />
                                //     <Column
                                //         cellRenderer={ this.typeCellRenderer }
                                //         name="Type"
                                //     />
                                //     <Column name="Capability" cellRenderer={ this.capabilityCellRenderer }/>
                                //     <Column name="Setup Fee" cellRenderer={ this.setupFeeCellRenderer }/>
                                //     <Column name="Monthly Fee" cellRenderer={ this.monthlyFeeCellRenderer }/>
                                // </Table>
                            }
                        </div>
                    </div>
                    <OrderSummary
                        orderAmount={this.state.fundsAmount}
                        vat={this.state.shouldAddVat ? parseInt(this.state.fundsAmount) * 0.2 : 0}
                        totalAmount={this.state.shouldAddVat ? parseInt(this.state.fundsAmount) + (parseInt(this.state.fundsAmount) * 0.2) : this.state.fundsAmount}
                        exclVat={0}
                        newBalance={this.state.fundsAmount}
                        withCheckout={true}
                        cartListTitle={'Phone Numbers'}
                        cartListSubtitle={'Monthly Subscription'}
                        cartList={this.state.addedNumbers}
                        cartItemIdentifier={'phoneNumber'}
                        cartCostIdentifier={'base_price'}
                        removeItem={this.removeFromCart}
                        handleSubmit={ !this.state.fundsAmount || (this.state.fundsAmount === '0') ? '' : this.handleProceedToCheckout}
                        checkoutDisabled={!this.state.fundsAmount || (this.state.fundsAmount === '0')}
                        spinner={this.state.spinnerActive}
                    />
                </div>
                <ClaimFreeNumberModal
                    showModal={this.state.claimFreeNumberModalActive}
                    handleClose={()=>this.setState({claimFreeNumberModalActive: false})}
                    number={this.state.claimFreeNumberModalData && this.state.claimFreeNumberModalData.length && this.state.claimFreeNumberModalData[0].phone ?
                        this.state.claimFreeNumberModalData[0].phone : ''}
                    workspaceName={this.props.selectedSourceNode && this.props.selectedSourceNode.name ?
                        this.props.selectedSourceNode.name : ''}
                    handleClaimNumber={this.claimFreeNumberSubmit}
                    loaderActive={this.state.claimFreeNumberLoader}
                    showFreeNumberSuccessText={this.state.showFreeNumberSuccessText}
                    handleContinuePurchase={this.handleFreeNumberFinishedContinuePurchase}
                    handleGoBack={this.handleFreeNumberFinishedGoBack}
                />
                {/*{console.log('Add funds object: ', this.state)}*/}
            </div>
        );
    }
}

export default sizeMe()(PhoneNumbers);